import LeadActionModel from '@/models/lead/lead-action-model'

export default class LeadModel {
  userName = ''

  path!: LeadActionModel[]
}
